module.exports = __webpack_public_path__ + "img/about_swiper3.223475c2.jpg";